<template>
  <div class="user-main">
    <!-- header -->
    <div class="myHeader">
      <el-row>
        <el-col class="logoStyle" :span="7">
          <p>四川省省级河长应用系统</p>
        </el-col>
        <el-col :span="9">
          <el-row>
            <el-col class="tabarList tabarActive" :span="4"
              >河湖综合信息</el-col
            >
            <el-col class="tabarList" :span="4">工作监督</el-col>
            <el-col class="tabarList" :span="4">问题监督</el-col>
            <el-col class="tabarList" :span="4">工作用图</el-col>
            <el-col class="tabarList" :span="4">三维实景</el-col>
            <el-col class="tabarList" :span="4">帮助中心</el-col>
          </el-row>
          <div class="hwbmb">
            <p class="h20-center" v-for="item in 4" :key="item">基础信息</p>
          </div>
        </el-col>
        <el-col :span="8">
          <el-col :span="10" :offset="14">
            <el-row>
              <el-col :span="4">
                <svg
                  t="1583459347174"
                  class="icon w100-mar-top1d5h"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="1282"
                >
                  <path
                    d="M790.4 371.17c-28.24-98.68-119.12-170.92-226.88-170.92-110 0-202.49 75.33-228.6 177.23a211.72 211.72 0 0 0-21.48-1.1c-115 0-208.31 93.27-208.31 208.31S198.39 793 313.44 793h443.14c117.23 0 212.26-95 212.26-212.26 0-105.74-77.29-193.37-178.44-209.57z"
                    fill="#CEE9F4"
                    p-id="1283"
                  />
                  <path
                    d="M706.58 779H516a16 16 0 0 1 0-32h190.58c108.22 0 196.26-88 196.26-196.26 0-97-69.38-178.46-165-193.77A16 16 0 0 1 725 345.58c-26.85-93.81-113.82-159.33-211.5-159.33a219.8 219.8 0 0 0-213.1 165.2 16 16 0 0 1-17.13 11.95 196.18 196.18 0 0 0-19.85-1c-106 0-192.31 86.27-192.31 192.31S157.4 747 263.44 747h26.4a16 16 0 0 1 0 32h-26.4a224.31 224.31 0 0 1 0-448.62q4.81 0 9.66 0.21a252.06 252.06 0 0 1 479.73-3.4A228.27 228.27 0 0 1 706.58 779z"
                    fill
                    p-id="1284"
                  />
                  <path
                    d="M486 843.9c0 55.72-30.91 77.3-69 77.3s-69-21.58-69-77.3 69-124.49 69-124.49 69 68.77 69 124.49z"
                    fill="#F7D134"
                    p-id="1285"
                  />
                  <path
                    d="M404 905.59c-22.35 0-41.18-6.93-54.44-20.06-15-14.83-22.6-36.78-22.6-65.23 0-58.37 68.48-127.26 71.39-130.16a8 8 0 0 1 11.29 0C412.55 693 481 761.93 481 820.3c0 28.45-7.6 50.4-22.59 65.23-13.25 13.13-32.08 20.06-54.41 20.06z m0-198.16c-16.1 17.5-61 70.19-61 112.87 0 57.27 33.19 69.29 61 69.29s61-12 61-69.29c0-42.74-44.91-95.38-61-112.87z"
                    fill
                    p-id="1286"
                  />
                </svg>
              </el-col>
              <el-col :span="10">
                <span>25°C | 良</span>
              </el-col>
              <el-col :span="10">
                <p class="date">2018/06/20</p>
                <p class="weather">多云转晴</p>
              </el-col>
            </el-row>
          </el-col>
        </el-col>
      </el-row>
    </div>
    <!-- content -->
    <div class="content">
      <!-- search -->
      <div class="pst_rel">
        <input type="text" class="Search" />
        <svg
          t="1583460046699"
          class="icon pst_abs"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2067"
          width="25"
          height="25"
        >
          <path
            d="M885.333333 846.933333L785.066667 746.666667c125.866667-147.2 121.6-369.066667-17.066667-507.733334-145.066667-145.066667-381.866667-145.066667-526.933333 0-145.066667 145.066667-145.066667 381.866667 0 526.933334 72.533333 72.533333 168.533333 108.8 262.4 108.8 87.466667 0 172.8-29.866667 243.2-91.733334l100.266666 100.266667 38.4-36.266667zM277.333333 729.6C153.6 605.866667 153.6 403.2 277.333333 277.333333c61.866667-61.866667 142.933333-93.866667 226.133334-93.866666 81.066667 0 164.266667 32 226.133333 93.866666 123.733333 123.733333 123.733333 326.4 0 452.266667-123.733333 123.733333-326.4 123.733333-452.266667 0z"
            fill
            p-id="2068"
          />
        </svg>
      </div>
      <!-- right -->
      <div class="hwbmb2">
        <div class="he-line-marbot">
          <el-row>
            <el-col :span="12">巡河次数（本月）</el-col>
            <el-col :span="4" :offset="8">更多》</el-col>
          </el-row>
        </div>
        <div clas="height20h">
          <el-row class="hei_line33">
            <el-col :span="6" class="center">巡河总数</el-col>
            <el-col :span="14" class="el-col2">
              <div class="el-col3">
                <div class="el-col4"></div>
              </div>
            </el-col>
            <el-col :span="4">1056次</el-col>
          </el-row>
          <el-row class="hei_line33">
            <el-col :span="6" class="center">发现问题</el-col>
            <el-col :span="14" class="el-col2">
              <div class="el-col3-1">
                <div class="el-col4"></div>
              </div>
            </el-col>
            <el-col :span="4">1056次</el-col>
          </el-row>
          <el-row class="hei_line33">
            <el-col :span="6" class="center">巡河总数</el-col>
            <el-col :span="14" class="el-col2">
              <div class="el-col5">
                <div class="el-col6"></div>
              </div>
            </el-col>
            <el-col :span="4">1056次</el-col>
          </el-row>
        </div>
        <div class="height25h">
          <el-row class="height3h">
            <el-col class="pad-left20" :span="12">四张清单</el-col>
            <el-col class="center" :span="6" :offset="6">更多></el-col>
          </el-row>
          <el-row class="height22h">
            <el-col class="h11h-marbot2h" :span="8" :offset="2">
              <el-progress
                width="80"
                type="circle"
                :percentage="92"
              ></el-progress>
              <p class="w100-pad-left10">目标清单</p>
            </el-col>
            <el-col class="h11h-marbot2h" :span="8" :offset="6">
              <el-progress
                width="80"
                type="circle"
                :percentage="80"
              ></el-progress>
              <p class="w100-pad-left10">目标清单</p>
            </el-col>
            <el-col class="h11h-marbot2h" :span="8" :offset="2">
              <el-progress
                width="80"
                type="circle"
                :percentage="95"
              ></el-progress>
              <p class="w100-pad-left10">目标清单</p>
            </el-col>
            <el-col class="h11h-marbot2h" :span="8" :offset="6">
              <el-progress
                width="80"
                type="circle"
                :percentage="77"
              ></el-progress>
              <p class="w100-pad-left10">目标清单</p>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- footer -->
    <footer class="myFooter">
      <el-row>
        <el-col class="footerNei padding1w" :span="7">
          <el-row
            style="height:3vh;line-height:2vh;border-bottom:1px solid #eee;margin-bottom:2vh"
            class="hwbmb3"
          >
            <el-col :span="24">成都水六厂</el-col>
          </el-row>
          <el-row>
            <el-col class="bg-cor1" :span="13">
              <el-row class="he2h-martop-bot1h">
                <el-col class="center" :span="8">断面信息</el-col>
                <el-col class="center" :span="4" :offset="8">详情></el-col>
              </el-row>
              <el-row>
                <el-col class="center pst-rel" :span="12">
                  <div class="footer-div"></div>
                  水泵：长江
                </el-col>
                <el-col class="center pst-rel" :span="12">
                  <div class="footer-div"></div>
                  区域：成都
                </el-col>
                <el-col class="center pst-rel" :span="12">
                  <div class="footer-div"></div>
                  水泵：长江
                </el-col>
                <el-col class="center pst-rel" :span="12">
                  <div class="footer-div"></div>
                  区域：成都
                </el-col>
                <el-col class="center pst-rel" :span="12">
                  <div class="footer-div"></div>
                  水泵：长江
                </el-col>
              </el-row>
            </el-col>
            <el-col class="bg-hei-bor" :span="10">
              <el-row class="he2h-martop-bot1h">
                <el-col class="center" :span="8">断面信息</el-col>
                <el-col class="center" :span="4" :offset="8">详情></el-col>
              </el-row>
              <el-row>
                <el-col class="po-re-padlef" :span="24">
                  <div class="totality"></div>
                  水质类别：1类
                </el-col>
                <el-col class="po-re-padlef" :span="24">
                  <div class="totality"></div>
                  发布时间：2017/12/25/8:22:28
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
        <el-col class="footerNei" :span="5">
          <div class="totality2">
            <el-row class="totality3">
              <el-col class="center" :span="8">历史数据</el-col>
              <el-col class="center" :span="8" :offset="8">查看更多</el-col>
            </el-row>
          </div>
          <div id="one" class="one"></div>
        </el-col>
        <el-col class="footerNei" :span="5">
          <div class="totality2">
            <el-row class="totality3">
              <el-col class="center" :span="8">平面河流断面监测</el-col>
              <el-col class="center" :span="8" :offset="8">查看更多</el-col>
            </el-row>
            <el-row class="pad-top2h">
              <el-col class="box" :span="7">
                <h2>4582</h2>
                <p>视屏点(个)</p>
              </el-col>
              <el-col class="box" :span="7">
                <h2>968</h2>
                <p>覆盖河道(条)</p>
              </el-col>
              <el-col class="box" :span="7">
                <h2>371</h2>
                <p>覆盖水库(个)</p>
              </el-col>
            </el-row>
            <el-row class="pad-top2h">
              <el-col class="box" :span="11">
                <h2>1972</h2>
                <p>水库监测点(个)</p>
              </el-col>
              <el-col class="box" :span="11">
                <h2>6328</h2>
                <p>水清监测点(个)</p>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col class="footerNei" :span="4">
          <div class="totality2">
            <el-row class="totality3">
              <el-col :span="8">河流巡河统计</el-col>
              <el-col :span="8" :offset="8">查看更多</el-col>
            </el-row>
          </div>
          <div id="two" class="one"></div>
        </el-col>
      </el-row>
    </footer>
  </div>
</template>

<script>
export default {
  name: "sichuan",
  data() {
    return {
      searchWord: ""
    };
  },
  mounted() {
    this.dianliang();
  },
  methods: {
    dianliang() {
      var myChart = this.$echarts.init(document.getElementById("one"));
      var myChart2 = this.$echarts.init(document.getElementById("two"));
      var option = {
        tooltip: {
          trigger: "axis"
        },
        toolbox: {
          show: false,
          feature: {
            mark: {
              show: true
            },
            dataView: {
              show: true,
              readOnly: true
            },
            magicType: {
              show: false,
              type: ["line", "bar"]
            },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
              "13",
              "14",
              "15",
              "16",
              "17",
              "18",
              "19",
              "20",
              "21",
              "22",
              "23",
              "24",
              "25",
              "26",
              "27",
              "28",
              "29"
            ],
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisTick: {
              show: false
            },
            splitLine: {
              show: true
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgb(204, 204, 204)"
              }
            },
            axisLine: {
              lineStyle: {
                color: "rgb(68, 136, 187)"
              }
            }
          }
        ],
        series: [
          {
            type: "bar",
            name: "-",
            barGap: 0,
            data: [
              0.2,
              0.9,
              0.7,
              0.3,
              0.6,
              0.7,
              0.12,
              0.61,
              0.26,
              0.45,
              0.39,
              0.33,
              0.46,
              0.2,
              0.9,
              0.7,
              0.3,
              0.6,
              0.7,
              0.12,
              0.61,
              0.26,
              0.45,
              0.39,
              0.33,
              0.46,
              0.7,
              0.3,
              0.33,
              0.46,
              0.2,
              0.9,
              0.7,
              0.3,
              0.6,
              0.7,
              0.12,
              0.61,
              0.26,
              0.2,
              0.9,
              0.7,
              0.3,
              0.6,
              0.7,
              0.12,
              0.61,
              0.26,
              0.45,
              0.39,
              0.33,
              0.46,
              0.2,
              0.9,
              0.7,
              0.3,
              0.6,
              0.7,
              0.12,
              0.61,
              0.26,
              0.45,
              0.39,
              0.33,
              0.46,
              0.7,
              0.3,
              0.33,
              0.46,
              0.2,
              0.2,
              0.9,
              0.7,
              0.3,
              0.6,
              0.7,
              0.39,
              0.33,
              0.9,
              0.2,
              0.9,
              0.7
            ],
            itemStyle: {
              normal: {
                color: "rgb(29, 187, 55)"
              }
            }
          }
        ],
        backgroundColor: "rgba(0, 0, 0, 0)",
        grid: {
          backgroundColor: "rgba(0, 0, 0, 0)",
          left: "2%",
          right: "2%",
          bottom: "3%",
          containLabel: true
        }
      };
      var option2 = {
        tooltip: {
          trigger: "axis"
        },
        toolbox: {
          show: false,
          feature: {
            mark: {
              show: true
            },
            dataView: {
              show: true,
              readOnly: true
            },
            magicType: {
              show: false,
              type: ["line", "bar"]
            },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月"],
            axisLine: {
              show: true
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgb(249, 194, 201)"
              }
            },
            axisTick: {
              show: false,
              interval: 0,
              inside: true
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgb(204, 204, 204)"
              }
            },
            splitArea: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisTick: {
              show: false
            },
            splitLine: {
              show: true
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgb(204, 204, 204)"
              }
            },
            axisLine: {
              lineStyle: {
                color: "rgb(68, 136, 187)"
              }
            }
          }
        ],
        series: [
          {
            type: "bar",
            name: "第一个数据",
            barGap: 0,
            data: [1100, 1756, 1590, 1541, 1789, 1893, 1852],
            itemStyle: {
              normal: {
                color: "#3aa1ff"
              }
            }
          },
          {
            type: "bar",
            name: "第二个数据",
            data: [1000, 1501, 1200, 1756, 1652, 1895, 1657],
            itemStyle: {
              normal: {
                color: "#50e468"
              }
            }
          }
        ],
        backgroundColor: "rgba(0, 0, 0, 0)",
        grid: {
          backgroundColor: "rgba(0, 0, 0, 0)",
          left: "2%",
          right: "2%",
          bottom: "3%",
          containLabel: true
        }
      };
      myChart.setOption(option);
      myChart2.setOption(option2);
    }
  }
};
</script>
<style lang="scss" scoped>
.user-main {
  font-family: å¾®è½¯é›…é»‘, MicrosoftYahei, sans-serif;
  color: #eee;
  width: 100%;
  height: 100%;
  background: url(../../assets/dataViewImg/background.png);
  background-size: 100% 100%;
  background-position: 0px 0px;
  background-repeat: no-repeat;
}
.content {
  width: 99%;
  height: 70vh;
  padding: 2vw;
  position: relative;
  box-sizing: border-box;
  .Search {
    width: 100%;
    height: 100%;
    border-radius: 20px;
    outline-color: #eee;
    background: rgba(24, 31, 28, 0.3);
    outline-color: none;
    border: 1px solid #eee;
  }
}
.myHeader {
  height: 8vh;
  width: 100%;
  display: inline-block;
  box-sizing: border-box;
  background: rgba(24, 31, 28, 0.6);
  text-align: center;
  line-height: 8vh;
  .logoStyle {
    font-size: 1.5vw;
  }
  .tabarList {
    font-size: 0.8vw;
  }
  .tabarActive {
    background: #080a08;
  }
}
.myFooter {
  width: 100%;
  height: 22vh;
  background: rgba(24, 31, 28, 0.1);
  box-sizing: border-box;
  .footerNei {
    background: rgba(24, 31, 28, 0.3);
    border-radius: 20px;
    height: 20vh;
    margin-left: 2vw;
    margin-top: 1vh;
    margin-bottom: 1vh;
    box-sizing: border-box;
    position: relative;
  }
}
// 新增
.hwbmb {
  height: 17vh;
  width: 8vw;
  background: rgba(0, 244, 255, 0.3);
  margin-top: 1vh;
  border-radius: 3px;
}
.h20-center {
  height: 20%;
  text-align: center;
}
.w100-mar-top1d5h {
  width: 100%;
  margin-top: 1.5vh;
}
.date {
  font-size: 0.6vw;
  height: 100%;
  line-height: 100%;
  margin-top: 2vh;
}
.weather {
  font-size: 0.8vw;
  height: 100%;
  line-height: 100%;
  margin-top: 2vh;
}
.pst_rel {
  width: 14vw;
  height: 3vh;
  position: relative;
}
.pst_abs {
  position: absolute;
  top: 2px;
  right: 10px;
}
.hwbmb2 {
  width: 21vw;
  height: 53vh;
  position: absolute;
  top: 4vh;
  right: 1vw;
  background: rgba(0, 0, 0, 0.3);
  padding: 2vw;
}
.he-line-marbot {
  height: 2vh;
  line-height: 2vh;
  margin-bottom: 3vh;
}
.height20h {
  height: 20vh;
}
.hei_line33 {
  height: 33%;
  line-height: 33%;
}
.center {
  text-align: center;
}
.el-col2 {
  background: #eee;
  height: 1.6vh;
  margin-top: -0.6vh;
  border-radius: 20px;
}
.el-col3 {
  background: #02ecb6;
  width: 74%;
  height: 1.6vh;
  border-radius: 20px;
}
.el-col4 {
  background: #eee;
  width: 10%;
  height: 100%;
  border-radius: 50%;
  margin-left: 85%;
  box-sizing: border-box;
}
.el-col3-1 {
  background: #ff7b4e;
  width: 60%;
  height: 1.6vh;
  border-radius: 20px;
}
.el-col5 {
  background: #c12829;
  width: 35%;
  height: 1.6vh;
  border-radius: 20px;
}
.el-col6 {
  background: #eee;
  width: 20%;
  height: 100%;
  border-radius: 50%;
  margin-left: 70%;
  box-sizing: border-box;
}
.height25h {
  height: 25vh;
}
.height3h {
  height: 3vh;
}
.pad-left20 {
  padding-left: 20px;
}
.height22h {
  height: 22vh;
}
.h11h-marbot2h {
  height: 11vh;
  margin-bottom: 2vh;
}
.w100-pad-left10 {
  width: 100%;
  padding-left: 10%;
}
.padding1w {
  padding: 1vw;
}
.hwbmb3 {
  height: 3vh;
  line-height: 2vh;
  border-bottom: 1px solid #eee;
  margin-bottom: 2vh;
}
.bg-cor1 {
  background: rgba(0, 0, 0, 0.15);
  height: 12vh;
  border-radius: 15px;
}
.he2h-martop-bot1h {
  height: 2vh;
  margin-top: 1vh;
  margin-bottom: 1vh;
}
.pst-rel {
  position: relative;
}
.footer-div {
  width: 10px;
  height: 10px;
  border-radius: 45%;
  background: #29d1e0;
  position: absolute;
  top: 5px;
  left: 15px;
}
.po-re-padlef {
  position: relative;
  padding-left: 2vw;
}
.totality {
  width: 10px;
  height: 10px;
  border-radius: 45%;
  background: #29d1e0;
  position: absolute;
  top: 5px;
  left: 15px;
}
.totality2 {
  position: absolute;
  top: 0;
  height: 20%;
  width: 100%;
}
.totality3 {
  margin-top: 1%;
  padding-bottom: 2%;
  border-bottom: 1px solid #eee;
}
.pad-top2h {
  padding-top: 2vh;
}
.box {
  border-radius: 10px;
  height: 6vh;
  background: rgba(0, 0, 0, 0.4);
  padding-top: 0.5vh;
  margin-left: 0.7vw;
  text-align: center;
}
</style>
